import type { SortByOptions } from '@lib/types/product-list'

import CategoryTextNodes from '@data/i18n/category.json'

type Props = {
	sortByOptions: SortByOptions
	setSortByOptions: (sortByOptions: SortByOptions) => void
}

export default function SortProducts({ sortByOptions, setSortByOptions }: Props) {
	const handleSortBy = (sortBy: SortByOptions['sortBy']) => {
		setSortByOptions({ sortBy, reverse: !sortByOptions.reverse })
	}

	return (
		<div className="flex justify-end gap-x-6">
			{/* TODO: Need way to unset this */}
			<button
				type="button"
				className="font-medium"
				onClick={() => handleSortBy('PRICE')}
			>
				<span>{CategoryTextNodes.products.price}</span>
				<i
					className={`ml-2 fa-fw fa-regular ${
						// eslint-disable-next-line no-nested-ternary
						sortByOptions.sortBy === 'PRICE' && !sortByOptions.reverse
							? 'fa-arrow-down-short-wide'
							: sortByOptions.sortBy === 'PRICE' && sortByOptions.reverse
							? 'fa-arrow-up-wide-short'
							: 'fa-arrow-up-arrow-down'
					} text-bbx-spark`}
				/>
			</button>

			{/* TODO: handle sort by ratings; removed 05/27/2022 */}
			{/* <button type="button" className="font-medium">
				Rating
			</button> */}
		</div>
	)
}
